import * as React from 'react';
import classNames from 'classnames';

import './styles.scss';

export interface IButtonsProps {
    /** style to pass */
    style?: React.CSSProperties;
    /** size to use */
    size?: 'default' | 'small';
    /** style to use */
    layout?: 'default' | 'reversed' | 'centered' | 'vertical' | 'vertical-wide' | 'sticky' | 'none';
    /** className to append */
    className?: string;
}

interface IState {
    heightCompensate: number;
}

type Props = IButtonsProps;

/**
 * Displays Buttons
 */
class Buttons extends React.Component<Props, IState> {
    static displayName: string = 'Buttons';

    private cachedWindowWidth: number = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || document.getElementsByTagName('body')[0].clientWidth;
    private cachedWindowHeight: number = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || document.getElementsByTagName('body')[0].clientHeight;
    private cachedHeight: number = 0;
    private buttonBar;

    constructor (props: Props) {
        super(props);
        this.state = {
            heightCompensate: 0,
        };
    }

    handleWindowResize = () => {
        const currentWidth: number = window.innerWidth || (document.documentElement && document.documentElement.clientWidth) || document.getElementsByTagName('body')[0].clientWidth;
        const currentHeight: number = window.innerHeight || (document.documentElement && document.documentElement.clientHeight) || document.getElementsByTagName('body')[0].clientHeight;
        if (currentWidth !== this.cachedWindowWidth || currentHeight !== this.cachedWindowHeight) {
            this.handleResize();
        }
    };

    handleResize = () => {
        if (typeof this.buttonBar === 'object' && this.buttonBar !== null) {
            const elementHeight = this.buttonBar.offsetHeight;
            if (elementHeight !== this.cachedHeight) {
                this.cachedHeight = elementHeight;
                this.setState({
                    heightCompensate: elementHeight,
                });
            }
        }
    };

    componentDidMount () {
        if (this.props.layout === 'sticky') {
            window.addEventListener('resize', this.handleWindowResize);
        }
    }

    componentWillUnmount () {
        if (this.props.layout === 'sticky') {
            window.removeEventListener('resize', this.handleWindowResize);
        }
    }

    render () {
        if (React.Children.toArray(this.props.children).length === 0) {
            return null;
        }

        if (this.props.layout === 'vertical') {
            return (
                <div className={classNames('buttons', 'layout-vertical', this.props.className)}>
                    <Buttons {...this.props} layout="vertical-wide"/>
                </div>
            );
        } else {
            return (
                <ul
                    className={classNames('buttons', {
                        'layout-default': this.props.layout === 'default' || !this.props.layout,
                        'layout-centered': this.props.layout === 'centered',
                        'layout-reversed': this.props.layout === 'reversed',
                        'layout-vertical-wide': this.props.layout === 'vertical-wide',

                        'size-small': this.props.size === 'small',
                    }, this.props.className)}
                    style={this.props.style}
                >
                    {React.Children.map(this.props.children, (child: any) => {
                        if (typeof child === 'string' || child === null || !child.type || !child.type.displayName) {
                            return child;
                        }
                        const name = child.type.displayName;

                        if (
                            name === 'Button' ||
                            name === 'ButtonIcon' ||
                            name === 'ButtonWithIcon' ||
                            name === 'Dropzone' ||
                            name === 'WithStyles(Button)' ||
                            name === 'WithStyles(ButtonIcon)' ||
                            name === 'WithStyles(ButtonWithIcon)' ||
                            name === 'WithStyles(Dropzone)' ||
                            name.startsWith('JssContextSubscriber')
                        ) {
                            return (
                                <li key={child.key} className="primary">{child}</li>
                            );
                        } else if (
                            name === 'ButtonsPrimary' ||
                            name === 'ButtonsSecondary'
                        ) {
                            return React.Children.map(child.props.children, (sub, subindex) => {
                                if (typeof child === 'string' || child === null) {
                                    return child;
                                }
                                return (
                                    <li
                                        key={subindex}
                                        className={classNames({
                                            primary: name === 'ButtonsPrimary',
                                            secondary: name === 'ButtonsSecondary',
                                        })}
                                    >{sub}</li>
                                );
                            });
                        } else {
                            return child;
                        }
                    })}
                </ul>
            );
        }
    }
}

export default Buttons;
